import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import {
  SortByEnum,
  SortOrderEnum,
} from '../../../entity-data/entity-data.data';
import { IMasterListHeader } from '../../../entity-master/components/master-list/master-list.interface';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

@Injectable()
export class SearchTrackedTimeListBuilder {
  constructor(
    private _translateService: TranslateService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildListHeaders(
    trackingObject: ITrackingObject,
    trackingScreenName: TrackingScreenNamesEnum | string,
    relevancySearchMode: boolean
  ): List<IMasterListHeader> {
    return List([
      {
        id: 'tracked-time-client-name',
        label: this._translateService.instant(
          'TRACKED_TIME.LIST_HEADERS.CLIENT'
        ),
        customClass: 'tracked-time-client-name',
        sortBy: SortByEnum.client_name,
        sortOrder: SortOrderEnum.asc,
        disableSorting: relevancySearchMode,
        trackingObject,
        trackingAction: this._trackingActionBuilder.buildButtonTapped(
          'sort_client',
          trackingScreenName
        ),
      },
      {
        id: 'tracked-time-start-date',
        label: this._translateService.instant('TRACKED_TIME.LIST_HEADERS.DATE'),
        customClass: 'tracked-time-start-date',
        sortBy: SortByEnum.start_date,
        sortOrder: SortOrderEnum.desc,
        disableSorting: relevancySearchMode,
        trackingObject,
        trackingAction: this._trackingActionBuilder.buildButtonTapped(
          'sort_date',
          trackingScreenName
        ),
      },
      {
        id: 'tracked-time-notes',
        label: this._translateService.instant(
          'TRACKED_TIME.LIST_HEADERS.NOTES'
        ),
        customClass: 'tracked-time-notes',
      },
      {
        id: 'tracked-time-status',
        label: this._translateService.instant(
          'TRACKED_TIME.LIST_HEADERS.STATUS'
        ),
        customClass: 'tracked-time-status',
      },
      {
        id: 'tracked-time-duration',
        label: this._translateService.instant(
          'TRACKED_TIME.LIST_HEADERS.DURATION'
        ),
        customClass: 'tracked-time-duration',
      },
    ]);
  }
}
